function translateWithDefault(t, key, defaultValue, options = {}) {
  if (typeof t !== 'function') return defaultValue;
  return t(key, {
    defaultValue,
    ...options,
  });
}

export function countWords(content) {
  const matches = content.trim().match(/\S+/g);
  return matches ? matches.length : 0;
}

export function countNonEmptyLines(content) {
  return content
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean).length;
}

export function formatConstraintLabel(challenge, t) {
  if (!challenge) return translateWithDefault(t, 'challengesRuntime.constraints.none', 'Open format');

  switch (challenge.constraintType) {
    case 'exact':
      if (challenge.buffer) {
        return translateWithDefault(
          t,
          'challengesRuntime.constraints.exactWordsWithBuffer',
          `Exactly ${challenge.targetValue} words (±${challenge.buffer})`,
          { count: challenge.targetValue, buffer: challenge.buffer },
        );
      }
      return translateWithDefault(
        t,
        'challengesRuntime.constraints.exactWords',
        `Exactly ${challenge.targetValue} words`,
        { count: challenge.targetValue },
      );
    case 'min':
      return translateWithDefault(
        t,
        'challengesRuntime.constraints.minWords',
        `${challenge.minValue}+ words`,
        { count: challenge.minValue },
      );
    case 'max':
      return translateWithDefault(
        t,
        'challengesRuntime.constraints.maxWords',
        `Up to ${challenge.maxValue} words`,
        { count: challenge.maxValue },
      );
    case 'range':
      return translateWithDefault(
        t,
        'challengesRuntime.constraints.rangeWords',
        `${challenge.minValue}-${challenge.maxValue} words`,
        { min: challenge.minValue, max: challenge.maxValue },
      );
    case 'exact_lines':
      return translateWithDefault(
        t,
        'challengesRuntime.constraints.exactLines',
        `Exactly ${challenge.targetValue} lines`,
        { count: challenge.targetValue },
      );
    case 'micro':
      return translateWithDefault(
        t,
        'challengesRuntime.constraints.microWords',
        `Exactly ${challenge.targetValue} words`,
        { count: challenge.targetValue },
      );
    case 'none':
    default:
      return translateWithDefault(t, 'challengesRuntime.constraints.none', 'Open format');
  }
}

export function formatTierLabel(requiredTier, t) {
  switch (requiredTier) {
    case 'all':
      return translateWithDefault(t, 'challengesRuntime.tiers.all', 'All writers');
    case 'ink':
      return translateWithDefault(t, 'challengesRuntime.tiers.ink', 'Ink+');
    case 'master':
      return translateWithDefault(t, 'challengesRuntime.tiers.master', 'Master+');
    case 'legend':
      return translateWithDefault(t, 'challengesRuntime.tiers.legend', 'Legend');
    default:
      return translateWithDefault(t, 'challengesRuntime.tiers.all', 'All writers');
  }
}

export function formatReviewQueueLabel(reviewQueue, t) {
  return reviewQueue === 'judges'
    ? translateWithDefault(t, 'challengesRuntime.reviewQueues.judges', 'Judges review')
    : translateWithDefault(t, 'challengesRuntime.reviewQueues.community', 'Community review');
}

export function formatSubmissionStatus(status, t) {
  switch (status) {
    case 'draft':
      return translateWithDefault(t, 'challengesRuntime.submissionStatuses.draft', 'Draft');
    case 'submitted':
      return translateWithDefault(t, 'challengesRuntime.submissionStatuses.submitted', 'Submitted');
    case 'under_review':
      return translateWithDefault(t, 'challengesRuntime.submissionStatuses.underReview', 'Under review');
    case 'approved':
      return translateWithDefault(t, 'challengesRuntime.submissionStatuses.approved', 'Approved');
    case 'rejected':
      return translateWithDefault(t, 'challengesRuntime.submissionStatuses.rejected', 'Rejected');
    default:
      return translateWithDefault(t, 'challengesRuntime.submissionStatuses.draft', 'Draft');
  }
}

export function truncateText(content, maxLength = 220) {
  const normalized = content.replace(/\s+/g, ' ').trim();
  if (normalized.length <= maxLength) return normalized;
  return `${normalized.slice(0, maxLength).trimEnd()}…`;
}
